import { useEffect, useState } from "react"
import { getBreakpoint } from "@helpers"

const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState(getBreakpoint());

  useEffect(() => {
    const handleResize = () => setScreenSize(getBreakpoint());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return screenSize
}

export default useScreenSize